import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-toast',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
    @Input()
    message: string = '';

    @Input()
    type: string = 'info';

    @Input()
    title: string = '';

    @Input()
    icon: string = '';
}